<template>
  <table class="table-container main-page-table w-100 white users-table">
    <thead class="primary white--text">
      <td class="text-center" style="width: 50px">STT</td>
      <td class="text-center" style="width: 110px">Mã nhân viên</td>
      <td class="text-center" style="width: auto; min-width: 180px">
        Họ và tên
      </td>
      <td class="text-center" style="width: auto; min-width: 200px">Email</td>
      <td class="text-center" style="width: auto; min-width: 120px">
        Chức danh
      </td>
      <td class="text-center" style="width: 138px">Bộ phận</td>
      <td class="text-center" style="width: 160px">Bắt buộc 2FA</td>
      <td class="text-center" style="width: 190px">Khóa OTP</td>
    </thead>
    <tbody class="white" :class="loadingTable ? 'body-loading' : ''">
      <div class="absolute-loading" v-if="loadingTable">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <tr v-for="(data, idx) in listData" :key="data.id">
        <td class="text-center">{{ indexOffset + idx + 1 }}</td>
        <td class="text-center">{{ data.code || "-" }}</td>
        <td class="text-center">{{ data.name || "-" }}</td>
        <td class="text-center">{{ data.email || "-" }}</td>
        <td class="text-center">
          {{ data.position ? data.position.name : "-" }}
        </td>
        <td class="text-center">
          {{
            data.position && data.position.department
              ? data.position.department.name
              : "-"
          }}
        </td>
        <td class="text-center">
          <!-- Switch is read-only so its state always mirrors the server value;
               the wrapper click asks the container to request the change -->
          <div
            class="d-inline-flex justify-center pointer"
            @click="onToggle(data)"
          >
            <v-switch
              :input-value="!!data.two_factor_required"
              :loading="pendingIds.includes(data.id)"
              :disabled="pendingIds.includes(data.id)"
              readonly
              inset
              dense
              hide-details
              class="mt-0 pt-0"
            ></v-switch>
          </div>
        </td>
        <td class="text-center">
          <template v-if="data.otp_locked_until || data.otp_failed_count > 0">
            <div
              v-if="data.otp_locked_until"
              class="semantic_error--text"
              style="font-size: 13px"
            >
              Khóa tới {{ formatTime(data.otp_locked_until) }}
            </div>
            <div v-else style="font-size: 13px">
              Sai {{ data.otp_failed_count }} lần
            </div>
            <v-btn
              x-small
              depressed
              color="primary"
              class="mt-1 low-letter-spacing"
              :loading="pendingIds.includes(data.id)"
              :disabled="pendingIds.includes(data.id)"
              @click="onUnlock(data)"
            >
              Kích hoạt lại
            </v-btn>
          </template>
          <span v-else>-</span>
        </td>
      </tr>
      <tr v-if="isFirstLoading">
        <td colspan="100" class="text-center py-5 pb-0">Đang tải dữ liệu...</td>
      </tr>
      <tr v-if="isFirstLoading">
        <td colspan="100" class="text-center py-5 pb-0">
          <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
        </td>
      </tr>
      <tr
        v-if="!isFirstLoading && (!listData || !listData.length)"
        class="no-data"
      >
        <td colspan="100" class="text-center py-5">
          <EmptyBody :isSearch="isSearch" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import EmptyBody from "./EmptyBody.vue"
export default {
  components: { EmptyBody },
  props: {
    listData: {
      type: Array,
      default() {
        return []
      },
    },
    pendingIds: {
      type: Array,
      default() {
        return []
      },
    },
    indexOffset: {
      type: Number,
      default: 0,
    },
    onToggle: {
      type: Function,
      default() {},
    },
    onUnlock: {
      type: Function,
      default() {},
    },
    isFirstLoading: {
      type: Boolean,
      default: true,
    },
    isSearch: {
      type: Boolean,
      default: true,
    },
    loadingTable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // ISO -> "HH:mm dd/MM" theo giờ máy người xem
    formatTime(iso) {
      const d = new Date(iso)
      const pad = (n) => String(n).padStart(2, "0")
      return `${pad(d.getHours())}:${pad(d.getMinutes())} ${pad(
        d.getDate(),
      )}/${pad(d.getMonth() + 1)}`
    },
  },
}
</script>
<style lang="scss" scoped>
.users-table {
  tbody {
    td {
      font-size: 14px !important;
    }
  }
  thead {
    position: sticky;
    top: 0;
    z-index: 3;
  }
}
.v-application {
  .body-loading {
    opacity: 0.8;
    pointer-events: none;
    position: relative;
  }
  .absolute-loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    min-height: 200px;
    background-color: rgba(239, 240, 240, 0.563) !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
